import React from "react";

const ContactUs = () => (
  <div className="max-w-4xl mx-auto p-6 font-sans">
    <h1 className="text-3xl font-bold text-green-700 mb-6 text-center">Contact Us – JR Home Foods</h1>
    
    <div className="space-y-8">
      <div className="text-center mb-8">
        <h2 className="text-xl font-semibold text-green-700 mb-3">We're here to help!</h2>
        <p className="text-gray-700 leading-relaxed">
          If you have any questions about your subscription, delivery, payment, refund, or anything else, feel free to reach out to us.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {/* Contact Information */}
        <div className="bg-white rounded-lg shadow-lg p-6 border border-green-100">
          <h3 className="text-lg font-bold text-green-700 mb-4 flex items-center">
            📬 Contact Information
          </h3>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <span className="text-green-600">📧</span>
              <div>
                <p className="font-medium text-gray-800">Email:</p>
                <a 
                  href="mailto:help.jrhomefoods@gmail.com" 
                  className="text-green-600 hover:text-green-800 underline"
                >
                  help.jrhomefoods@gmail.com
                </a>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <span className="text-green-600">📞</span>
              <div>
                <p className="font-medium text-gray-800">Phone:</p>
                <a 
                  href="tel:+917893816225" 
                  className="text-green-600 hover:text-green-800 underline"
                >
                  +91-7893816225
                </a>
              </div>
            </div>
            <div className="flex items-start space-x-3">
              <span className="text-green-600">📍</span>
              <div>
                <p className="font-medium text-gray-800">Address:</p>
                <p className="text-gray-700">
                  JR-Home Made Foods<br />
                  Hyderabad, Telangana<br />
                  India – 502032
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Customer Support Hours */}
        <div className="bg-white rounded-lg shadow-lg p-6 border border-green-100">
          <h3 className="text-lg font-bold text-green-700 mb-4 flex items-center">
            🕐 Customer Support Hours
          </h3>
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span className="text-gray-700">Monday to Sunday:</span>
              <span className="font-medium text-green-700">9:00 AM – 6:00 PM</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-700">Monday:</span>
              <span className="font-medium text-red-600">Closed</span>
            </div>
            <p className="text-sm text-gray-600 mt-3">
              <em>(except for urgent delivery queries)</em>
            </p>
          </div>
        </div>
      </div>

      {/* Compliance Note */}
      <div className="bg-green-50 rounded-lg p-6 border border-green-200">
        <h3 className="text-lg font-bold text-green-700 mb-4 flex items-center">
          🔒 Compliance Note
        </h3>
        <p className="text-gray-700 mb-4">
          We respond to all queries related to:
        </p>
        <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-4">
          <li>Subscription plan changes or cancellations</li>
          <li>Delivery issues or rescheduling</li>
          <li>Refund and payment disputes (as per <a href="/cancellation-refund" className="text-green-600 hover:text-green-800 underline">Refund Policy</a>)</li>
          <li>Feedback or complaints</li>
        </ul>
        <p className="text-gray-700 font-medium">
          As required by consumer law and our payment gateway, we are committed to responding to refund or support queries within <strong>2 business days</strong>.
        </p>
      </div>

      {/* Quick Actions */}
      <div className="bg-white rounded-lg shadow-lg p-6 border border-green-100">
        <h3 className="text-lg font-bold text-green-700 mb-4">🚀 Quick Actions</h3>
        <div className="grid md:grid-cols-2 gap-4">
          <div className="text-center p-4 bg-green-50 rounded-lg">
            <div className="text-2xl mb-2">📋</div>
            <h4 className="font-semibold text-green-700 mb-2">My Plans</h4>
            <p className="text-sm text-gray-600">Manage your subscription</p>
          </div>
          <div className="text-center p-4 bg-green-50 rounded-lg">
            <div className="text-2xl mb-2">❓</div>
            <h4 className="font-semibold text-green-700 mb-2">Help Center</h4>
            <p className="text-sm text-gray-600">Find answers to common questions</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ContactUs; 